import { countBy, entries, map } from 'lodash/fp';
import { createSelector } from 'reselect';
import { composeProps, createPropsExtender } from '@mews/framework';
import { ResourceState } from '@mews-commander/legacy-data-structures';
import { getContainer } from '@mews-commander/legacy-app-instance';
import { getColorFromResourceState } from '@mews-commander/utils';
import { getNonSlotServiceResources } from '@mews-commander/legacy-entities/src/selectors/spaces';
import { getSelectedServiceId } from '@mews-commander/legacy-entities/src/ducks/serviceSelect';

export const getCurrentServiceResources = composeProps(
    getNonSlotServiceResources,
    createPropsExtender('serviceId', getSelectedServiceId)
);

const getResourceStateData = createSelector(getCurrentServiceResources, countBy('state'));

export const getResourceStateValues = createSelector(getResourceStateData, getContainer, (data, container) =>
    map(([key, value]) => {
        const { appLocalizationComponent } = container();
        // @ts-expect-error $TSFixMeError: Argument of type 'string' is not assignable to parameter of type '"Dirty" | "Clean" | "Inspected" | "OutOfService" | "Ou...
        const resourceState = ResourceState.getByName(key);
        const label = appLocalizationComponent.localizeEnumify(resourceState);
        const color = getColorFromResourceState(resourceState.value);
        return {
            color,
            value,
            label,
        };
    }, entries(data))
);
